export default {
  header: {
    title: 'Kod promocyjny lub karta podarunkowa',
  },
  available_codes: {
    title_one: 'Dostępny kod ({{count}})',
    title_few: 'Dostępne kody ({{count}})',
    title_many: 'Dostępne kody ({{count}})',
    title_other: 'Dostępne kody ({{count}})',
    min_threshold: 'Min. {{value}}',
    percentage_off: '{{discount}}% zniżki na to zamówienie',
    amount_off: '{{amount}} zniżki na to zamówienie',
  },
  content: {
    input: {
      placeholder: 'Wpisz kod',
    },
    buttons: {
      done: 'Gotowe',
      apply: 'Zastosuj',
      applied: 'Zastosowano ✓',
    },
  },
};
